// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/addUserIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Add" aria-label="Add" />;
}
